let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lq077")).then(() => parcelRequire('23teI'));